<script lang="ts">
	export let toggle = false;
	export let firstText = "";
	export let secondText = "";
</script>

<div
	class="container"
	t-id="TextSwitch"
	class:leftMove={!toggle}
	class:rightMove={toggle}
	on:click={() => (toggle = !toggle)}
>
	<div class="shadow" />
	<div class="first"><span>{firstText}</span></div>
	<div class="second"><span>{secondText}</span></div>
</div>

<style lang="scss">
	@import "../variables.scss";
	.container {
		position: relative;
		display: flex;
		width: 300px;
		height: 35px;
		border: 1px solid #b4b7bb;
		border-radius: 22.5px;
		background-color: white;
		cursor: pointer;

		.shadow {
			position: absolute;
			width: 164px;
			height: 31px;
			top: 2px;
			left: 2px;
			border-radius: 20px;
			background-color: #6d6f76;
			transition: 0.2s;
		}

		&.leftMove {
			.shadow {
				transform: translate(0px);
			}
			.first {
				span {
					color: white;
					transition: 0.2s;
				}
			}
			.second {
				span {
					color: #bcbfc3;
					transition: 0.2s;
				}
			}
		}

		&.rightMove {
			.shadow {
				transform: translate(132px);
			}
			.first {
				span {
					color: #bcbfc3;
					transition: 0.2s;
				}
			}
			.second {
				span {
					color: white;
					transition: 0.2s;
				}
			}
		}

		.first {
			display: flex;
			justify-content: center;
			align-items: center;
			width: 50%;
			z-index: 1;
			span {
				@include appleAdjustTextForSize(16, false);
				font-weight: 400;
			}
		}
		.second {
			display: flex;
			justify-content: center;
			align-items: center;
			width: 50%;
			z-index: 1;
			span {
				@include appleAdjustTextForSize(16, false);
				font-weight: 400;
			}
		}
	}
	@include DesktopSize {
		.container {
			position: relative;
			display: flex;
			width: 340px;
			height: 48px;
			border: 1px solid #b4b7bb;
			border-radius: 22.5px;
			background-color: white;
			cursor: pointer;

			.shadow {
				position: absolute;
				width: 164px;
				height: 40px;
				top: 4px;
				left: 4px;
				border-radius: 20px;
				background-color: #6d6f76;
				transition: 0.2s;
			}

			&.leftMove {
				.shadow {
					transform: translate(0px);
				}
				.first {
					span {
						color: white;
						transition: 0.2s;
					}
				}
				.second {
					span {
						color: #bcbfc3;
						transition: 0.2s;
					}
				}
			}

			&.rightMove {
				.shadow {
					transform: translate(166px);
				}
				.first {
					span {
						color: #bcbfc3;
						transition: 0.2s;
					}
				}
				.second {
					span {
						color: white;
						transition: 0.2s;
					}
				}
			}

			.first {
				display: flex;
				justify-content: center;
				align-items: center;
				width: 50%;
				z-index: 1;
				span {
					@include appleAdjustTextForSize(16, false);
					font-weight: 400;
				}
			}
			.second {
				display: flex;
				justify-content: center;
				align-items: center;
				width: 50%;
				z-index: 1;
				span {
					@include appleAdjustTextForSize(16, false);
					font-weight: 400;
				}
			}
		}
	}
</style>
